// Main menu behaviour

class MainMenu {
  /**
   *
   * @param {Object} All anchor tags in main menu with children
   */
  constructor(elements) {
    const mobileMenu = document.querySelector(".bibu-responsive-menu");
    const mobileMenuParent = mobileMenu.querySelectorAll(
      ".menu__item--has-children > a"
    );

    this.toggleMainMenu(elements);
    this.preventDefaultOnMenuItems(elements);
    this.preventDefaultOnMenuItems(mobileMenuParent);
    this.handleCloseMenuClick();
    this.toggleMobileMenu(mobileMenu);
  }

  /**
   *
   * @param {Object} menuItems
   *
   * Adds a listener on all elements in main menu with children
   */
  toggleMainMenu(menuItems) {
    menuItems.forEach((menuItem) => {
      menuItem.addEventListener("click", (event) => {
        const menuIsActive = document.querySelectorAll(
          ".menu__item--active"
        ).length;

        if (menuIsActive) {
          // Check if the clicked element contains the --active class, if it does
          // toggle it otherwise run toggleActiveMenuItem()
          menuItem.parentElement.classList.contains("menu__item--active")
            ? event.target.parentElement.classList.toggle("menu__item--active")
            : this.toggleActiveMenuItems(menuItem);
        } else {
          // If menu is not active set the --active class on the clicked element
          event.target.parentElement.classList.toggle("menu__item--active");
        }

        // toggle noscroll class on body
        this.toggleBodyScroll();
      });
    });
  }

  /**
   *
   * @param {Object} clickedMenuItem
   */

  // Toggle the --active class on the current active menu element and
  // add the --active class to the clicked element
  toggleActiveMenuItems(clickedMenuItem) {
    const currentActiveMenuItem = document.querySelector(".menu__item--active");
    currentActiveMenuItem.classList.toggle("menu__item--active");
    clickedMenuItem.parentElement.classList.toggle("menu__item--active");
  }

  /**
   *
   * @param {Object} itemsWithChildren
   */

  // Prevent the top lvl menu items with children from behaving like links
  preventDefaultOnMenuItems(itemsWithChildren) {
    itemsWithChildren.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
      });
    });
  }

  /**
   * When menu is active remove scrolling of body
   */
  toggleBodyScroll() {
    const menuIsActive = document.querySelectorAll(
      ".menu__item--active"
    ).length;

    if (menuIsActive) {
      document.documentElement.classList.add("noscroll");
    } else {
      document.documentElement.classList.remove("noscroll");
    }
  }

  toggleMobileBodyScroll() {
    document.documentElement.classList.toggle("noscroll");
  }

  /**
   * Close menu on button click
   */
  handleCloseMenuClick() {
    document.querySelectorAll(".menu__close-button").forEach((button) => {
      button.addEventListener("click", (event) => {
        document
          .querySelector(".menu__item--active")
          .classList.toggle("menu__item--active");
        this.toggleBodyScroll();
      });
    });

    document
      .querySelectorAll(".bibu-responsive-menu__close-button")
      .forEach((button) => {
        button.addEventListener("click", (event) => {
          document
            .querySelector(".bibu-responsive-menu--active")
            .classList.toggle("bibu-responsive-menu--active");
          this.toggleBodyScroll();
        });
      });
  }

  toggleMobileMenu(mobileMenu) {
    // Get current url
    const url = window.location.href;
    // Check if url contains /en/ or /sv/ and set language variable
    let language = "";

    if (url.includes("/en/")) {
      language = "en";
    //   console.log("language: ", language);
    } else {
      language = "sv";
    //   console.log("language: ", language);
    }

    document
      .querySelector(".menu__mobile-button")
      .addEventListener("click", (event) => {
        if (event.target.classList.contains("menu__mobile-button--active")) {
          event.target.setAttribute(
            "aria-label",
            language === "en" ? "Open menu" : "Öppna menyn"
          );

          console.log("event.target: ", event.target);
        } else {
          event.target.setAttribute("aria-expanded", "true");
          event.target.setAttribute(
            "aria-label",
            language === "en" ? "Close menu" : "Stäng menyn"
          );
        }

        const mobileMenuFirstInterativeElement = mobileMenu.querySelector("a");
        const activeMenuItems = document.querySelectorAll(
          ".menu__item--active"
        );

        mobileMenuFirstInterativeElement.focus();

        activeMenuItems.forEach((menuItem) => {
          menuItem.classList.remove("menu__item--active");
        });

        event.target.classList.toggle("menu__mobile-button--active");
        mobileMenu.classList.toggle("bibu-responsive-menu--active");

        this.toggleMobileBodyScroll();
      });
  }
}

export default MainMenu;
